import { Badge } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { SubscriptionFlagsEnum } from '~/constants/enums';
import { PlanType } from '~/types/subscriptionTypes';
export default function PlanCardWrapper({
  children,
  plan,
}: {
  children: React.ReactNode;
  plan: PlanType;
}) {
  const { t } = useTranslation('app');
  const hasDiscount = Boolean(plan.price_before_discount);
  const priceBeforeDiscount = plan.price_before_discount ?? 0;
  const amountOfDiscount = priceBeforeDiscount - Number(plan.price);
  const discountPercentage = Math.round(
    (amountOfDiscount / priceBeforeDiscount) * 100,
  );
  const flagsLabel: Record<SubscriptionFlagsEnum, string> = {
    [SubscriptionFlagsEnum.BEST_SELLER]: t('bestSeller'),
    [SubscriptionFlagsEnum.BEST_FOR_BRANDING]: t('bestForBranding'),
    [SubscriptionFlagsEnum.BIGGEST_DISCOUNT]: hasDiscount
      ? `${t('saveIt')} ${discountPercentage}%`
      : t('biggestDiscount'),
    [SubscriptionFlagsEnum.RECOMMENDED]: t('recommended'),
    [SubscriptionFlagsEnum.SPECIAL_OFFER]: t('specialOffer'),
  };
  return plan.flag ? (
    <div className="plan-card-wrapper  border rounded-[12px] border-orange">
      <div className="flex justify-between p-2x bg-orange_light_2 rounded-t-[12px] card-header  ">
        <p className="text-title_3 text-orange_dark_2">{plan.title}</p>
        <Badge
          text={flagsLabel[plan.flag as SubscriptionFlagsEnum]}
          className="rounded-[4px] bg-orange text-black"
        />
      </div>
      <div className="flex flex-col gap-2x h-full justify-between  rounded-b-[12px] px-2x pt-2x pb-3x">
        {children}
      </div>
    </div>
  ) : (
    <div className="plan-card-wrapper ">
      <div className="flex p-2x bg-gray_light_1 rounded-t-[12px] card-header ">
        <p className="text-title_3">{plan.title}</p>
      </div>
      <div className="flex flex-col gap-2x h-full justify-between  rounded-b-[12px] px-2x pt-2x pb-3x border  border-t-0 border-gray">
        {children}
      </div>
    </div>
  );
}
